<ion-grid class="ion-no-padding">
  <ion-row
    class="ion-no-padding ion-no-margin ion-justify-content-center ion-align-items-center row-style"
  >
    <ion-card class="no-shadow ion-padding ion-text-center">
      <custom-icon
        [iconName]="image"
        [width]="170"
        [height]="170"
        colorClass="modalIcon"
        class="ion-padding"
      ></custom-icon>
      <ion-text class="ion-no-padding">
        <p class="font20 font600 card-primary-text-color">
          {{ message | translate }}
        </p>
        <p class="fs-3 font500 message2 card-primary-text-color">
          {{ message2 | translate }}
        </p>
      </ion-text>
      <ion-button
        expand="block"
        class="ion-no-margin fs-3 font500 primary-btn"
        (click)="updateApp()"
      >
        <ion-ripple-effect></ion-ripple-effect>
        {{ "update_app_cmp.update_now_btn" | translate }}
      </ion-button>
      <ion-button
        class="clear-btn"
        *ngIf="!forceUpdate"
        (click)="closeModal()"
        fill="clear"
      >
        Not Now
      </ion-button>
    </ion-card>
  </ion-row>
</ion-grid>
